import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import { STUDENT_PROJECTS } from '@lib/data/course-landing-page'

const IMAGE_PATH = '/images/courses/'

type Props = {
  courseName: string
}

const StudentProjects = ({ courseName }: Props) => {
  const projects = STUDENT_PROJECTS[courseName]

  return (
    <div className="mt-16 mb-8 flex flex-col text-grey">
      <h2 className="text-2xl font-600 leading-tight">{projects.heading} </h2>
      <div className="flex mt-4 flex-wrap justify-center">
        {projects.contents.map((project, i) => (
          <div
            key={i}
            className="max-w-xs w-full sm:w-1/2 md:w-full lg:w-1/2 xl:w-1/3 my-2 px-1 bg-white"
          >
            <div className="rounded-md shadow-md hover:shadow-xl transition duration-500 cursor-pointer h-full">
              <FastlyImage
                src={`${IMAGE_PATH}${project.image.name}.png`}
                webpSrc={`${IMAGE_PATH}${project.image.name}.webp`}
                width={492}
                height={334}
                objectFit="fill"
                alt={project.image.alt}
              />
              <div className="flex flex-col p-3 w-full">
                <div className="flex justify-between">
                  <p className="text-grey-800">{project.category}</p>
                  <p className="text-orange">{project.studentGrade}</p>
                </div>
                <h3 className="text-xl font-600 mt-2 leading-tight">
                  {project.title}
                </h3>
              </div>
              <div className="mt-auto p-3">
                <p className="text-orange font-600 mb-2">
                  {project.studentName}
                </p>
                {project.link && (
                  <a href={project.link} target="_blank" rel="noreferrer">
                    <Button>View project</Button>
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default StudentProjects
